import React from "react";
import { Box, useTheme } from "@mui/material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";
import { useAuth } from "../../../auth/hooks/useAuth";
import { LogoutDialog } from "./LogoutDialog";

const drawerWidth = 280;

export const DashboardLayout: React.FC = () => {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [logoutDialogOpen, setLogoutDialogOpen] = React.useState(false);
  const [isLoggingOut, setIsLoggingOut] = React.useState(false);
  console.log(JSON.stringify(user, undefined, 2));
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleLogoutClick = () => {
    setLogoutDialogOpen(true);
  };

  const handleLogoutCancel = () => {
    if (!isLoggingOut) {
      setLogoutDialogOpen(false);
    }
  };

  const handleLogoutConfirm = async () => {
    try {
      setIsLoggingOut(true);
      await logout();
      navigate("/auth/login");
    } catch (error) {
      console.error("Logout failed:", error);
      setIsLoggingOut(false);
    } finally {
      setLogoutDialogOpen(false);
    }
  };

  if (!user) {
    return null; // or a loading spinner, or redirect to login
  }

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <Header
        drawerWidth={drawerWidth}
        onDrawerToggle={handleDrawerToggle}
        onLogout={handleLogoutClick}
        user={{
          first_name: user.first_name,
          last_name: user.last_name,
          business_name: user?.business?.business_name || "Business Name",
        }}
        mobileOpen={mobileOpen}
      />
      <Sidebar
        drawerWidth={drawerWidth}
        mobileOpen={mobileOpen}
        onDrawerToggle={handleDrawerToggle}
        onLogout={handleLogoutClick}
        currentPath={location.pathname}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 2, md: 3, lg: 4 },
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          height: { xs: `calc(100vh - 70px)`, md: `calc(100vh - 80px)` },
          mt: { xs: "70px", md: "80px" },
          overflowY: "auto",
          bgcolor:
            theme.palette.mode === "dark"
              ? theme.palette.background.default
              : theme.palette.grey[50],
        }}
      >
        <Outlet />
      </Box>
      <LogoutDialog
        open={logoutDialogOpen}
        onClose={handleLogoutCancel}
        onConfirm={handleLogoutConfirm}
        isLoading={isLoggingOut}
      />
    </Box>
  );
};
